import { useRecoilState, useRecoilValue } from "recoil";
import { forceRender, misReport, reportToggle } from "../../state/atom/report";
import { gisFeatureLayerFilter, misSummaryFilter } from "../../state/atom/gis";
import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import fileDownload from "js-file-download";
import { Button, Modal, Pagination } from "react-bootstrap";
import { SkeletonComp } from "../../shared/Skeleton/Skeleton";
import { Http } from "../../utility/http";
import { apiHeaders } from "../../utility/generic";
import { getUserDetails } from "../../utility/jwt";
import { JwtPayLoad } from "../../shared/jwt.interface";
import { checkPermission } from "../../utility/permission";

export const MisList = () => {
  const [repoToggle, setReportToggle] = useRecoilState(reportToggle);
  const misReportData = useRecoilValue(misReport);
  const misSummaryFilterData = useRecoilValue(misSummaryFilter);
  const [disableSummraybtn, setDisableSummarybtn] = useState(false);
  const forceRenderTrigger = useRecoilValue(forceRender);
  const [summaryType, setSummaryType] = useState("count");
  const [misFilterOptions, setMisFilterOptions] = useState({
    business: false,
    site: false,
  });
  let gisFeatureLayerFilterData = useRecoilValue(gisFeatureLayerFilter);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);
  const [show, setShow] = useState(false);
  const [isSavingRemark, setIsSavingRemark] = useState(false);
  const { user }: JwtPayLoad = getUserDetails();
  const controllerRef = useRef<AbortController | null>(null);
  const [searchSite, setSearchSite] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (
      misSummaryFilterData.Site === "" &&
      misSummaryFilterData.BusinessName === ""
    ) {
      setDisableSummarybtn(false);
      setMisFilterOptions((prevOptions) => ({
        ...prevOptions,
        business: false,
        site: false,
      }));
      setSummaryType("count");
    } else {
      setDisableSummarybtn(true);
    }
  }, [misSummaryFilterData.BusinessName, misSummaryFilterData.Site]);

  useEffect(() => {
    setIsLoading(true);
    Http.request(
      "post",
      `${process.env.REACT_APP_API_URL}land-parcel/mis/report`,
      {
        filterDataSet: {
          countWise: true,
        },
      },
      apiHeaders()
    )
      .then((result) => {
        setIsLoading(false);
        setCountSummaryData(result?.data);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, []);

  const toggleSummary = (type: string) => {
    setSummaryType(type);
    setIsLoading(true);
    setMisFilterOptions((prevOptions) => ({
      ...prevOptions,
      business: false,
      site: false,
    }));
    Http.request(
      "post",
      `${process.env.REACT_APP_API_URL}land-parcel/mis/report`,
      {
        filterDataSet: {
          countWise: type === "count" ? true : false,
          areaWise: type === "area" ? true : false,
        },
      },
      apiHeaders()
    )
      .then((result) => {
        setIsLoading(false);
        if (type === "count") {
          setCountSummaryData(result?.data);
        } else {
          setAreaSummaryData(result?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const [areaSummaryData, setAreaSummaryData] = useState([]);
  const [countSummaryData, setCountSummaryData] = useState([]);
  const [businessWiseReportData, setBusinessWiseReportData] = useState([]);
  const [siteWiseReportData, setSiteWiseReportData] = useState([]);
  // Calculate the range of visible pages based on the current page
  const [currentPage, setCurrentPage] = useState<number>(1);
  const ITEMS_PER_PAGE: number = 20;
  const TOTAL_PAGES = Math.ceil(siteWiseReportData.length / ITEMS_PER_PAGE);
  const VISIBLE_PAGE = 5;
  const startPage = Math.max(1, currentPage - Math.floor(VISIBLE_PAGE / 2));
  const endPage = Math.min(TOTAL_PAGES, startPage + VISIBLE_PAGE - 1);

  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

  const B_ITEMS_PER_PAGE = 10;
  const [businessCurrentPage, setBusinessCurrentPage] = useState<number>(1);
  const [BUSINESS_TOTAL_PAGES, setBUSINESSTOTALPAGES] = useState(0);
  const [businessStartPage, setbusinessStartPage] = useState(0);
  const [businessEndPage, setbusinessEndPage] = useState(0);
  const [indexOfBusinessLastItem, setindexOfBusinessLastItem] = useState(0);
  const [indexOfBusinessFirstItem, setindexOfBusinessFirstItem] = useState(0);

  //-------------------//
  /* const [page, setPage] = useState(1);
  const [limit] = useState(10); // rows per page
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState<number>(1); */

  const [totalPages, setTotalPages] = useState(0);
  //const [businessCurrentPage, setCurrentPage] = useState(1);
  const limit = 10; // rows per page

  //-------------------//

  const [requestId, setRequestId] = useState("");
  const [requestName, setRequestName] = useState("");
  const [requestComment, setRequestComment] = useState("");

  useEffect(() => {
    if (gisFeatureLayerFilterData.Site) {
      setDisableSummarybtn(true);
      setMisFilterOptions((prevOptions) => ({
        ...prevOptions,
        site: true,
        business: false,
      }));
      setSummaryType("");
      setIsLoading(true);
      Http.request(
        "post",
        `${process.env.REACT_APP_API_URL}land-parcel/mis/report`,
        {
          filterDataSet: {
            businessWise: gisFeatureLayerFilterData.BusinessName,
            siteWise: gisFeatureLayerFilterData.Site,
          },
        },
        apiHeaders()
      )
        .then((result) => {
          setIsLoading(false);
          setSiteWiseReportData(result?.data);
        })
        .catch((error) => {
          setIsLoading(false);
        });

      setCurrentPage(1);
    } else if (
      gisFeatureLayerFilterData.BusinessName ||
      gisFeatureLayerFilterData.State ||
      gisFeatureLayerFilterData.CompanyName
    ) {
      setDisableSummarybtn(true);
      setMisFilterOptions((prevOptions) => ({
        ...prevOptions,
        business: true,
        site: false,
      }));
      setSummaryType("");
      setIsLoading(true);
      Http.request(
        "post",
        `${process.env.REACT_APP_API_URL}land-parcel/mis/report`,
        {
          filterDataSet: {
            businessWise: gisFeatureLayerFilterData.BusinessName,
            stateWise: gisFeatureLayerFilterData.State,
            companyWise: gisFeatureLayerFilterData.CompanyName,
          },
        },
        apiHeaders()
      )
        .then((result) => {
          setIsLoading(false);
          setBusinessWiseReportData(result?.data);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } else if (
      !gisFeatureLayerFilterData?.BusinessName &&
      !gisFeatureLayerFilterData?.State &&
      !gisFeatureLayerFilterData?.CompanyName &&
      !gisFeatureLayerFilterData?.Site
    ) {
      setDisableSummarybtn(false);
      setMisFilterOptions((prevOptions) => ({
        ...prevOptions,
        business: false,
        site: false,
      }));
      setSummaryType("count");

      setIsLoading(true);
      Http.request(
        "post",
        `${process.env.REACT_APP_API_URL}land-parcel/mis/report`,
        {
          filterDataSet: {
            countWise: true,
          },
        },
        apiHeaders()
      )
        .then((result) => {
          setIsLoading(false);
          setCountSummaryData(result?.data);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  }, [misReportData, gisFeatureLayerFilterData, forceRenderTrigger]);

  const exportToXls = () => {
    if (summaryType === "area") {
      exportAreaSummary();
    } else if (summaryType === "count") {
      exportCountSummary();
    } else if (misFilterOptions.business || misFilterOptions.site) {
      exportMisFilterSummary();
    }
  };

  const exportAreaSummary = () => {
    const exportData = areaSummaryData.map(convertValuesToFloat);
    const fileName = "Summary Area Wise";
    if (exportData.length) {
      createXLSFile(exportData, fileName);
    }
  };

  const exportCountSummary = () => {
    const fileName = "Summary Count Wise";
    if (countSummaryData.length) {
      createXLSFile(countSummaryData, fileName);
    }
  };

  const exportMisFilterSummary = async () => {
    if (misFilterOptions.business && businessWiseReportData.length) {
      let exportData;
      if (summaryType === "business") {
        exportData = await allBusinessWiseSummaryExport();
        exportData.forEach((obj: any) => {
          delete obj.requestId;
        });
      } else {
        exportData = businessWiseReportData.map(convertValuesToFloat);

        exportData.forEach((obj) => {
          delete obj.requestId;
        });
      }

      console.log("exportData", exportData);
      const fileName = "Business Wise Report";
      createXLSFile(exportData, fileName);
    } else if (misFilterOptions.site && siteWiseReportData.length) {
      const exportData = siteWiseReportData.map(convertValuesToFloat);
      const fileName = "Site Wise Report";
      createXLSFile(exportData, fileName);
    }
  };

  const createXLSFile = (summaryReportData: any, fileName: string) => {
    if (summaryReportData.length) {
      const worksheet = XLSX.utils.json_to_sheet(summaryReportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const dataBlob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      fileDownload(dataBlob, `${fileName}.xlsx`);
    }
  };

  const convertValuesToFloat = (obj: any) => {
    const floatObj: any = {};

    for (const key in obj) {
      const value = obj[key];

      // Skip float conversion for specific keys
      if (key === "Survey No") {
        floatObj[key] = value?.toString(); // Ensure string
        continue;
      }

      const floatVal = parseFloat(value);
      floatObj[key] = isNaN(floatVal) ? value : floatVal;
    }

    return floatObj;
  };

  const allBusinessWiseSummary = (pageNo: number, searchSite: string = "") => {
    // Cancel previous request if it exists
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create new controller for this request
    const controller = new AbortController();
    controllerRef.current = controller;

    setMisFilterOptions((prevOptions) => ({
      ...prevOptions,
      business: true,
      site: false,
    }));
    //setSummaryType("");
    setIsLoading(true);
    Http.request(
      "post",
      `${process.env.REACT_APP_API_URL}land-parcel/mis/report`,
      {
        filterDataSet: {
          businessWise1: "0",
          siteName: searchSite,
          page: pageNo,
          limit: B_ITEMS_PER_PAGE,
        },
      },
      apiHeaders(),
      controller.signal
    )
      .then((result) => {
        setIsLoading(false);
        if (result?.data.length) {
          setBusinessWiseReportData(result?.data);
          setTotalPages(Math.ceil(result.total / limit));
        } else {
          setBusinessWiseReportData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const allBusinessWiseSummaryExport = async (searchSite: string = "") => {
    setIsExportLoading(true);
    const result = await Http.request(
      "post",
      `${process.env.REACT_APP_API_URL}land-parcel/mis/report`,
      {
        filterDataSet: {
          businessWise1: "0",
          siteName: searchSite,
          page: 1,
          limit: 1000000,
        },
      },
      apiHeaders()
    );
    setIsExportLoading(false);
    return result?.data;
  };

  const handlePageChange = (page: number) => {
    console.log("page1", page);
    if (page >= 1 && page <= totalPages) {
      console.log("page2", page);
      setBusinessCurrentPage(page);
      allBusinessWiseSummary(page, searchSite);
    }
  };

  const renderPaginationItems = () => {
    let items = [];

    items.push(
      <Pagination.First
        key="first"
        onClick={() => handlePageChange(1)}
        disabled={businessCurrentPage === 1}
      />
    );

    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(businessCurrentPage - 1)}
        disabled={businessCurrentPage === 1}
      />
    );

    // Show up to 3 pages around current
    let start = Math.max(1, businessCurrentPage - 1);
    let end = Math.min(totalPages, businessCurrentPage + 1);

    if (start > 1) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let number = start; number <= end; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === businessCurrentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (end < totalPages) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    items.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(businessCurrentPage + 1)}
        disabled={businessCurrentPage === totalPages}
      />
    );

    items.push(
      <Pagination.Last
        key="last"
        onClick={() => handlePageChange(totalPages)}
        disabled={businessCurrentPage === totalPages}
      />
    );

    return items;
  };

  const getRequestDetails = (requestId: string) => {
    if (requestId) {
      Http.request(
        "get",
        `${process.env.REACT_APP_API_URL}land-request/${requestId}`,
        null,
        apiHeaders()
      )
        .then((result) => {
          setRequestName(result.data.landRequest?.requestName);
          setRequestComment(result.data.landRequest?.report_remark);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const saveRemark = () => {
    if (requestId) {
      setIsSavingRemark(true);
      Http.request(
        "put",
        `${process.env.REACT_APP_API_URL}land-request/report-remark/${requestId}`,
        {
          report_remark: requestComment,
        },
        apiHeaders()
      )
        .then((result) => {
          setIsSavingRemark(false);
          handleClose();
          setBusinessCurrentPage(1);
          allBusinessWiseSummary(1, searchSite);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <>
      <div className="box center-box">
        <div
          className=" a-link request-list-corner-btn request-list-corner-btn--collapsed "
          id="request-list-corner-btn"
          onClick={() => {
            setReportToggle(!repoToggle);
          }}
        >
          <span
            style={{ padding: "0 5px" }}
            className="nav-link font-weight-bold d-flex text-white corner-btn"
          >
            <i className="material-icons opacity-10 pe-1">checklist</i>
            <span className="d-sm-inline d-none dashboard-icons">MIS List</span>
          </span>
        </div>
        <div
          className={
            "request-list-init " +
            (!repoToggle ? "request-list-init--collapsed" : "")
          }
          style={{ width: "95%", overflowY: "scroll" }}
        >
          <div
            className="text-right panel-title mb-0"
            style={{
              background: "#375db1",
              alignItems: "center",
              position: "sticky",
              top: "0",
            }}
          >
            <div className="form-group d-flex justify-content-end  mx-5 my-2 mis-list-header">
              {misFilterOptions.site && siteWiseReportData.length > 0 && (
                <Pagination className="mx-5">
                  {currentPage > 1 && (
                    <>
                      <Pagination.First
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                      />
                      <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      />
                    </>
                  )}
                  {Array.from({ length: endPage - startPage + 1 }).map(
                    (_, index: number) => (
                      <Pagination.Item
                        className="bg-gradient"
                        key={startPage + index}
                        active={startPage + index === currentPage}
                        onClick={() => handlePageChange(startPage + index)}
                      >
                        {startPage + index}
                      </Pagination.Item>
                    )
                  )}
                  {currentPage !== TOTAL_PAGES && (
                    <>
                      <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === TOTAL_PAGES}
                      />
                      <Pagination.Last
                        onClick={() => handlePageChange(TOTAL_PAGES)}
                        disabled={currentPage === TOTAL_PAGES}
                      />
                    </>
                  )}
                </Pagination>
              )}

              {misFilterOptions.business &&
                summaryType === "business" &&
                businessWiseReportData.length > 0 && (
                  <Pagination>{renderPaginationItems()}</Pagination>
                )}

              <button
                type="button"
                key="business_summary"
                disabled={disableSummraybtn}
                style={{ marginRight: "5px" }}
                onClick={() => {
                  setBusinessCurrentPage(1);
                  allBusinessWiseSummary(1);
                  setSummaryType("business");
                  setMisFilterOptions((prevOptions) => ({
                    ...prevOptions,
                    business: true,
                  }));
                }}
                className={`btn bg-gradient-primary-login btn1 ${
                  summaryType === "business" ? "bg-primary bg-gradient" : ""
                }`}
              >
                BUSINESS SUMMARY
              </button>

              <button
                type="button"
                key="count_summary"
                disabled={disableSummraybtn}
                style={{ marginRight: "5px" }}
                onClick={() => toggleSummary("count")}
                className={`btn bg-gradient-primary-login btn1 ${
                  summaryType === "count" ? "bg-primary bg-gradient" : ""
                }`}
              >
                COUNT SUMMARY
              </button>
              <button
                type="button"
                key="area_summary"
                disabled={disableSummraybtn}
                style={{ marginRight: "5px" }}
                onClick={() => toggleSummary("area")}
                className={`btn bg-gradient-primary-login btn1 ${
                  summaryType === "area" ? "bg-primary bg-gradient" : ""
                }`}
              >
                AREA SUMMARY
              </button>
            </div>
            <span
              className="close-btn"
              id="request-list-close"
              onClick={() => {
                setReportToggle(!repoToggle);
              }}
            >
              &times;
            </span>
          </div>

          {misFilterOptions.business && (
            <>
              <div className="table-responsive p-0 dx-table-mis">
                <table
                  className="table align-items-center justify-content-center mb-0 text-white table-bordered text-center"
                  style={{ borderCollapse: "collapse", width: "100%" }}
                >
                  <thead
                    style={{
                      background: "#47a0e7d9",
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    <tr>
                      {businessWiseReportData.length > 0 &&
                        Object.keys(businessWiseReportData[0]).map((column) => {
                          return (
                            column !== "requestId" && (
                              <th
                                style={{
                                  background: "#47a0e7d9",
                                  padding: "8px 16px",
                                  width: `${column === "Remarks" ? "25%" : ""}`,
                                }}
                                className={`text-capitalize text-xxs font-weight-bolder`}
                              >
                                {column}
                              </th>
                            )
                          );
                        })}
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "14px" }}>
                    {isLoading && <SkeletonComp totalCol={9} />}
                    {!isLoading &&
                      businessWiseReportData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {Object.keys(businessWiseReportData[0]).map(
                            (header) =>
                              header !== "requestId" && (
                                <td
                                  style={{
                                    padding: "8px 16px",
                                  }}
                                  className="text-capitalize"
                                  key={header}
                                >
                                  {header === "Remarks" &&
                                    typeof row[header] === "string" && (
                                      <span>
                                        {(row[header] as string).split(" ")
                                          .length > 5 ? (
                                          <>
                                            {(row[header] as string)
                                              .split(" ")
                                              .slice(0, 5)
                                              .join(" ")}
                                            ...
                                            <span
                                              style={{
                                                color: "#fff",
                                                cursor: "pointer",
                                                marginLeft: 5,
                                                textDecoration: "underline",
                                              }}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setRequestId(row["requestId"]);
                                                getRequestDetails(
                                                  row["requestId"]
                                                );
                                                setRequestName("");
                                                setRequestComment("");
                                                handleShow();
                                              }}
                                            >
                                              Read more
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            {row[header]}

                                            <span
                                              style={{
                                                marginLeft: 8,
                                                cursor: "pointer",
                                                verticalAlign: "middle",
                                              }}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setRequestId(row["requestId"]);
                                                getRequestDetails(
                                                  row["requestId"]
                                                );
                                                setRequestName("");
                                                setRequestComment("");
                                                handleShow();
                                              }}
                                            >
                                              <i
                                                className="material-icons opacity-10 pe-1"
                                                title="Edit Remark"
                                              >
                                                edit
                                              </i>
                                            </span>
                                          </>
                                        )}
                                      </span>
                                    )}
                                  {header !== "Remarks" && row[header]}
                                </td>
                              )
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "5px 50px 5px 0",
                }}
              >
                {businessWiseReportData.length > 0 && (
                  <input
                    className="form-control export-btn"
                    style={{ left: "130px", width: "200px" }}
                    placeholder="Search Site"
                    value={searchSite}
                    onChange={(e) => {
                      setSearchSite(e.target.value);
                      setBusinessCurrentPage(1);
                      allBusinessWiseSummary(1, e.target.value);
                    }}
                  />
                )}

                {businessWiseReportData.length > 0 && (
                  <button
                    type="button"
                    key="business_summary"
                    disabled={isExportLoading}
                    onClick={exportToXls}
                    className="btn bg-gradient-primary-login btn1 export-btn"
                  >
                    {isExportLoading ? "EXPORTING.." : "EXPORT"}
                  </button>
                )}
              </div>
            </>
          )}
          {misFilterOptions.site && (
            <>
              <div className="table-responsive p-0 dx-table-mis">
                <table
                  className="table align-items-center justify-content-center mb-0 text-white table-bordered text-center"
                  style={{ borderCollapse: "collapse", width: "100%" }}
                >
                  <thead
                    style={{
                      background: "#47a0e7d9",
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    <tr>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Business
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Company Name
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Site Name
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Village
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Survey No
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Area (Acre)
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Land Type
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Sellers Name
                      </th>
                      {/* <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        LendersName
                      </th> */}
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Conveyance Deed (Y/N)
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Mutation (Y/N)
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        NA (Y/N)
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        TSR (Y/N)
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Conveyance Deed No
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Tehsil
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        District
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        State
                      </th>
                      <th className="text-capitalize text-xxs font-weight-bolder site-th">
                        Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "14px" }}>
                    {isLoading && <SkeletonComp totalCol={15} />}
                    {!isLoading &&
                      siteWiseReportData
                        .slice(indexOfFirstItem, indexOfLastItem)
                        .map((row: any, rowIndex) => (
                          <tr key={rowIndex}>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Business"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Company Name"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Site Name"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Village"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Survey No"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Area (Acre)"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Land Type"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Sellers Name"]}
                            </td>
                            {/* <td className="text-capitalize" key={rowIndex}>
                              {row["LendersName"]}
                            </td> */}
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Conveyance Deed (Y/N)"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Mutation (Y/N)"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["NA (Y/N)"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["TSR (Y/N)"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Conveyance Deed No"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Tehsil"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["District"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["State"]}
                            </td>
                            <td className="text-capitalize" key={rowIndex}>
                              {row["Remarks"]}
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "5px 50px 5px 0",
                }}
              >
                {siteWiseReportData.length > 0 && (
                  <button
                    type="button"
                    key="site_summary"
                    // disabled={disableSummraybtn}
                    onClick={exportToXls}
                    className="btn bg-gradient-primary-login btn1 export-btn-site"
                  >
                    EXPORT
                  </button>
                )}
              </div>
            </>
          )}

          {summaryType === "area" &&
            !misFilterOptions.business &&
            !misFilterOptions.site && (
              <>
                <div
                  className="table-responsive p-0 dx-table-mis"
                  /* style={{ height: "calc(100% - 25%)", overflowY: "auto" }} */
                >
                  <table
                    className="table align-items-center justify-content-center mb-0 text-white table-bordered text-center fix-column"
                    style={{ borderCollapse: "collapse", width: "100%" }}
                  >
                    <thead
                      style={{
                        background: "#47a0e7d9",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                      }}
                    >
                      <tr>
                        {areaSummaryData?.length > 0 &&
                          Object.keys(areaSummaryData[0]).map((column) => {
                            return (
                              <th
                                style={{
                                  background: "#47a0e7d9",
                                  padding: "8px 16px",
                                }}
                                className="text-capitalize text-xxs font-weight-bolder"
                              >
                                {column}
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: "14px" }}>
                      {isLoading && <SkeletonComp totalCol={15} />}
                      {!isLoading &&
                        areaSummaryData
                          ?.filter((a: any) => a["State"] && a["State"] !== "")
                          .map((row, rowIndex) => (
                            <tr style={{ position: "inherit" }} key={rowIndex}>
                              {Object.keys(areaSummaryData[0]).map((header) => (
                                <td
                                  style={{
                                    padding: "8px 16px",
                                  }}
                                  className="text-capitalize"
                                  key={header}
                                >
                                  {/* {handlerFormatter(row[header])} */}
                                  {row[header]}
                                </td>
                              ))}
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "5px 50px 5px 0",
                  }}
                >
                  {areaSummaryData?.length > 0 && (
                    <button
                      type="button"
                      key="area_summary"
                      // disabled={disableSummraybtn}
                      onClick={exportToXls}
                      className="btn bg-gradient-primary-login btn1 export-btn"
                    >
                      EXPORT
                    </button>
                  )}
                </div>
              </>
            )}

          {summaryType === "count" &&
            !misFilterOptions.business &&
            !misFilterOptions.site && (
              <>
                <div
                  className="table-responsive p-0 dx-table-mis"
                  /* style={{ height: "calc(100% - 25%)", overflowY: "auto" }} */
                >
                  <table
                    className="table align-items-center justify-content-center mb-0 text-white table-bordered text-center fix-column"
                    style={{ borderCollapse: "collapse", width: "100%" }}
                  >
                    <thead
                      style={{
                        background: "#47a0e7d9",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                      }}
                    >
                      <tr>
                        {countSummaryData?.length > 0 &&
                          Object.keys(countSummaryData[0]).map((column) => {
                            return (
                              <th
                                style={{
                                  background: "#47a0e7d9",
                                  padding: "8px 16px",
                                }}
                                className="text-capitalize text-xxs font-weight-bolder"
                              >
                                {column}
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      {isLoading && <SkeletonComp totalCol={15} />}
                      {!isLoading &&
                        countSummaryData
                          ?.filter((a: any) => a["State"] && a["State"] !== "")
                          .map((row, rowIndex) => (
                            <tr style={{ position: "inherit" }} key={rowIndex}>
                              {Object.keys(countSummaryData[0]).map(
                                (header) => (
                                  <td
                                    className="text-capitalize table-head"
                                    key={header}
                                    style={{ padding: "8px 16px" }}
                                  >
                                    {row[header]}
                                  </td>
                                )
                              )}
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "5px 50px 5px 0",
                  }}
                >
                  {countSummaryData?.length > 0 && (
                    <button
                      type="button"
                      key="count_summary"
                      // disabled={disableSummraybtn}
                      onClick={exportToXls}
                      className="btn bg-gradient-primary-login btn1 export-btn"
                    >
                      EXPORT
                    </button>
                  )}
                </div>
              </>
            )}
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            size="lg"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Site: {requestName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <textarea
                style={{ width: "100%" }}
                rows={10}
                onChange={(e) => {
                  setRequestComment(e.target.value);
                }}
                value={requestComment}
              ></textarea>
            </Modal.Body>
            {checkPermission(user?.role, "report", "can_edit_remark") && (
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={saveRemark}
                  disabled={isSavingRemark}
                >
                  {isSavingRemark ? "Saving..." : "Save"}
                </Button>
              </Modal.Footer>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
};
